import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    mainTitle: 'OUR TEAM',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Director of PT Kredit Pintar Indonesia',
    desc1: `Ronny Kasim, CFA is the company’s President Director. Ronny has around 30 years experience in risk management, banking, and capital market. Prior to joining Kredit Pintar, he has hold various positions in corporations located in Indonesia, the United States, France, United Arab Emirates, and Singapore including Chairman of Credit Bureau Indonesia (KBIJ), Director of Trusting Social Indonesia, President Director of Pefindo Kredit Biro, President Director of Pemeringkat Efek Indonesia, Project Manager of Moody’s, and Lead Business Analyst of First National Bank. Ronnie earned his BSBA in Finance and MBA degrees from Creighton University in the US and Doctoral degree in Leadership & Policy Innovation from Universitas Gadjah Mada. He is also a CFA Charterholder.`,
    // title2: 'Kokko Cattaka',
    // subTitle2: 'Director of PT Kredit Pintar Indonesia',
    // desc2: `Kokko has over 20 years of professional experience before joining Kredit Pintar, with a background in finance, FMCG, and various industry sectors. As an alumnus of the Faculty of Business and Economics at the University of Indonesia, he has held several key positions such as Chief Innovation Officer, Chief Operating Officer, and most recently served as Chief Operating Officer at fintech companies. Additionally, he serves as an advisor to several fintech startups, advocating for initiatives aimed at revolutionizing the financial landscape and enhancing inclusivity in Indonesia.`,
    title3: 'Irwan Prabowo',
    subTitle3: 'Director of PT Kredit Pintar Indonesia',
    desc3: `Irwan Prabowo is an IT executive with over 25 years of experience, currently leading the digital transformation at PT Kredit Pintar Indonesia. He holds an academic background from the Massachusetts Institute of Technology (specializing in Artificial Intelligence/Machine Learning), an MBA in Digital Leadership from the University of Reading, and certification in Harvard ManageMentor: Digital Intelligence. He is an expert in developing innovative solutions for the financial services sector, including fintech and digital transformation initiatives.`,
    desc3a: `His experience spans cross-functional team leadership at both local and regional levels, as well as key roles in companies such as IBM, Home Credit, Google Cloud Innovator, Red Hat, and Accenture. These roles have honed his ability to bridge business needs with technology. As a LinkedIn Top Voice and mentor, Irwan actively shares insights to promote inclusive technological innovation. Committed to inclusive financial solutions, he combines technical expertise with strategic leadership to ensure that PT Kredit Pintar's digital innovation continues to grow and deliver positive impact.`,
    title4: 'Wawan Salum',
    subTitle4: 'Commissioner of PT Kredit Pintar Indonesia',
    desc4: `Wawan Salum is the Commissioner of Kredit Pintar Indonesia. With excellent experiences in banking industry for more than 15 years, Wawan Salum was known to occupy various essential positions in several companies, such as Cards Marketing Director in Citi, Consumer Banking Director in HSBC, and Managing Director-Consumer Banking in DBS Bank. With exceptional track records and working experiences, Wawan Salum envisions Kredit Pintar Indonesia to be the company that gives huge contributions in financial inclusion acceleration in Indonesia.`,
  },
  id: {
    mainTitle: 'TIM KAMI',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Direktur PT Kredit Pintar Indonesia',
    desc1: `Ronny Kasim, CFA saat ini menjabat sebagai Direktur Utama perusahaan. Ronny mempunyai pengalaman hampir 30 tahun di dunia manajemen risiko, perbankan, dan pasar modal. Sebelum bergabung di Kredit Pintar, Ronny menjabat berbagai posisi kunci di beberapa perusahaan yang berlokasi di Indonesia, Amerika Serikat, Perancis, Uni Emirat Arab, dan Singapura. Posisi kunci yang pernah diembannya antara lain, Komisaris Utama Credit Bureau Indonesia (KBIJ), Direktur Trusting Social Indonesia, Direktur Utama Pefindo Biro Kredit, Direktur Utama Pemeringkat Efek Indonesia, Project Manager Moody’s, dan Lead Business Analyst First National Bank. Ronny mendapatkan gelar BSBA in Finance dan MBA dari Creighton University di Amerika Serikat serta gelar Doktor Kepemimpinan & Inovasi Kebijakan dari Universitas Gadjah Mada. Ronny juga mempunyai sertifikasi CFA.`,
    // title2: 'Kokko Cattaka',
    // subTitle2: 'Direktur PT Kredit Pintar Indonesia',
    // desc2: `Kokko memiliki lebih dari 20 tahun pengalaman profesional sebelum bergabung dengan Kredit Pintar, dengan latar belakang di bidang keuangan, FMCG, dan berbagai sektor industri. Sebagai alumnus Fakultas Bisnis dan Ekonomi Universitas Indonesia, beliau juga menduduku beberapai posisi kunci  sebagai Chief Innovation Officer,  Chief Operating Officer, dan terakhir menjabat sebagai Direktur Operasional di perusahaan fintech. Selain itu beliau juga menjabat sebagai penasihat beberapa startup fintech, beliau memperjuangkan inisiatif yang bertujuan untuk merevolusi lanskap keuangan dan meningkatkan inklusivitas di Indonesia.`,
    title3: 'Irwan Prabowo',
    subTitle3: `Direktur PT Kredit Pintar Indonesia`,
    desc3: `Irwan Prabowo adalah seorang eksekutif TI dengan pengalaman lebih dari 25 tahun, saat ini memimpin transformasi digital di PT Kredit Pintar Indonesia. Dengan latar belakang pendidikan dari Massachusetts Institute of Technology (spesialisasi Artificial Intelligence/Machine Learning), MBA, Digital Leadership dari University of Reading, dan Harvard ManageMentor: Digital Intelligence, ia ahli dalam menciptakan solusi inovatif untuk sektor jasa keuangan, termasuk fintech dan inisiatif transformasi digital.`,
    desc3a: `Pengalamannya mencakup kepemimpinan tim lintas fungsi di tingkat lokal dan regional, serta peran kunci di perusahaan seperti IBM, Home Credit, Google Cloud Innovator, Red Hat, dan Accenture, yang mengasah kemampuannya dalam menjembatani kebutuhan bisnis dengan teknologi. Sebagai LinkedIn Top Voice dan mentor, Irwan aktif berbagi wawasan untuk mendorong inovasi teknologi yang inklusif. Berkomitmen pada solusi keuangan inklusif, ia memadukan keahlian teknis dengan kepemimpinan strategis untuk memastikan inovasi digital PT Kredit Pintar terus berkembang.`,
    title4: 'Wawan Salum',
    subTitle4: 'Komisaris PT Kredit Pintar Indonesia',
    desc4: `Wawan Salum merupakan Komisaris Kredit Pintar Indonesia. Dengan pengalaman di dunia perbankan selama lebih dari 15 tahun, Wawan Salum tercatat pernah menduduki jabatan penting dalam perusahaan, seperti Cards Marketing Director di Citi, Consumer Banking Director di HSBC, dan Managing Director-Consumer Banking di DBS Bank. Dengan rekam jejak dan pengalaman kerja yang mumpuni, Wawan Salum memiliki visi untuk membawa Kredit Pintar Indonesia untuk menjadi perusahaan yang mampu memberikan kontribusi besar terhadap percepatan inklusi keuangan di Indonesia.`,
  },
})

const IntroduceHook = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/about/about-one.png',
      title: t('title1'),
      subtitle: t('subTitle1'),
      desc: t('desc1'),
    },
    // {
    //   img: '/images/about/about-two.jpeg',
    //   title: t('title2'),
    //   subtitle: t('subTitle2'),
    //   desc: t('desc2'),
    // },
    {
      img: '/images/about/about-three.png',
      title: t('title3'),
      subtitle: t('subTitle3'),
      desc: t('desc3'),
      desca: t('desc3a'),
    },
    {
      img: '/images/about/about-four.png',
      title: t('title4'),
      subtitle: t('subTitle4'),
      desc: t('desc4'),
    },
  ]
  return (
    <Introduce>
      <div className="main-title">{t('mainTitle')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <div key={index} className="item">
              <div className="img">
                <Reveal delay={100 + index * 30} animation={Animation.FadeIn}>
                  <LazyLoad>
                    <img src={item.img} alt={item.title} />
                  </LazyLoad>
                </Reveal>
              </div>
              <div className="text-group">
                <div className="title">{item.title}</div>
                <div className="subtitle">{item.subtitle}</div>
                { index !== 2 ? <div className="desc">{item.desc}</div>
                    : <div>
                        <div className="desc">{item.desc}</div>
                        <br/>
                        <div className="desc">{item.desca}</div>
                      </div>
                  }
              </div>
            </div>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }} scrollbar={{ draggable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <img src={item.img} alt={item.title} />
                    </LazyLoad>
                  </div>
                  <div className="title">{item.title}</div>
                  <div className="subtitle">{item.subtitle}</div>
                  { index !== 2 ? <div className="desc">{item.desc}</div>
                    : <div>
                        <div className="desc">{item.desc}</div>
                        <br/>
                        <div className="desc">{item.desca}</div>
                      </div>
                  }
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </Introduce>
  )
}

export default IntroduceHook

const Introduce = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 48px auto 0;
    text-align: center;
    width: 100%;
    .main-title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 24px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        margin: 0 auto;
        text-align: left;
        width: 272px;
        .img {
          width: 160px;
          height: 160px;
        }
        .title {
          padding-top: 24px;
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 21px;
        }
        .subtitle {
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #1cc812;
          line-height: 21px;
          margin: 8px auto 16px;
          min-height: 42px;
        }
        .desc {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 90px 150px 72px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .main-title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 48px;
    }
    .items {
      display: grid;
      grid-template-rows: repeat(4, max-content);
      grid-gap: 48px;
      .item {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-gap: 10px;
        text-align: left;
        .img {
          width: 160px;
          height: 160px;
        }
        .text-group {
          .title {
            font-size: 16px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #212121;
            line-height: 24px;
          }
          .subtitle {
            font-size: 18px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #1cc812;
            line-height: 24px;
            width: 90%;
            margin: 8px 0;
          }
          .desc {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #757575;
            line-height: 24px;
          }
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
`
